import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { ViewConstants } from 'src/app/constants';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { IAppCoreState } from 'src/app/core/state';
import { RightPanelItem, WriteupDetailRightPanelAction } from 'src/app/feature/writeups-detail/state/actions/writeup-detail-right-panel.action';
import { DealRoute } from 'src/app/shared/model/api';
import { getDetailsForInitiatedWriteup } from 'src/app/shared/state/selectors';
import { isNil } from 'lodash-es';
import * as appCustomerInfoActions from 'src/app/shared/state/actions/customer-info.action';
import { SubSink } from 'subsink';
import { FeatureFlagService } from 'src/app/environment/services/feature-flag.service';

@Component({
    selector: 'con-app-toaster',
    templateUrl: './con-app-toaster.html',
    styleUrls: ['con-app-toaster.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConAppToaster extends Toast implements OnInit{
  data;
  private readonly _subs = new SubSink();
  
  constructor(private readonly _store: Store<IAppCoreState>,toastrService: ToastrService,
        private readonly featureFlagService: FeatureFlagService,
        private readonly sharedDataService:SharedDataService, public toastPackage: ToastPackage, private readonly router: Router) {
    super(toastrService, toastPackage);
   }
  public ngOnInit() {
    this.data = this.toastPackage.config.payload
  }
  navigateToDetail(){
    const navExtra = this.getNavigationExtras(this.data?.fullToastObject);
    if(this.data.type === 'DEAL_COMMENT'){
    this._store.dispatch(new WriteupDetailRightPanelAction(RightPanelItem.Notes));
    }
    else if(this.data?.fullToastObject?.deal?.status?.toLowerCase() === ViewConstants.INITIATED.toLowerCase() && this.data?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase() && this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED')) 
        {
        let data ={};
        data['deal'] = {};
        data['deal']['dealTransactionId'] = this.data?.fullToastObject?.deal?.dealTransactionId;
        this._store.dispatch(appCustomerInfoActions.GetDealDetailsForInitiatedModalAction({ payload: data }));
          this._subs.sink = this._store.select(getDetailsForInitiatedWriteup)
        .subscribe((res: any) => {
          if(!isNil(res) && res.dealCallStatus) {
            this.sharedDataService.initiatedWriteupRowData = res.custWriteups;
            this.sharedDataService.initiatedWriteupRowData['deal'] ={}
            this.sharedDataService.initiatedWriteupRowData['deal']['status'] = this.data?.fullToastObject?.deal?.status;
            setTimeout(() => {
            this.sharedDataService.resFromNotificationCenter  =  true;
              this.sharedDataService.openInitiateModal = true;
              if (this.router.url?.includes('cs/customer-summary/')) {
                this.router.navigate(['/wl/summary']);
              }
            }, 800);
          }
          });
        }
    else if((this.data?.fullToastObject?.deal?.dealType === "TRADEIN" && this.data?.fullToastObject?.deal?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase() && this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED')) ||
        (this.featureFlagService.isFeatureEnabled('OCA_SUBMITTED') && this.data?.fullToastObject?.deal?.status?.toLowerCase() !== ViewConstants.INITIATED.toLowerCase() && this.data?.fullToastObject?.deal?.onlineStatus?.toLowerCase() === ViewConstants.INITIATED.toLowerCase() && this.data?.fullToastObject?.deal?.writeupType?.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase())){
          if(isNil(navExtra?.state?.dealType) || navExtra?.state?.dealType === ''|| navExtra?.state?.dealType.toLowerCase() === ViewConstants.CREDIT_APP_SUBMITTED.toLowerCase()){
            navExtra.state.dealType = "Trade";
          }
          this.router.navigate(['wd/writeup-detail'], navExtra);
    }
    else{
      this.router.navigate(['wd/writeup-detail'], navExtra);
    }
  }
  private getNavigationExtras(data) {
    const _dealType = data?.deal?.paymentType?.toLowerCase() ?? data?.deal?.dealType;
    const dealRoute: DealRoute = {
      customer: data?.customer ? data.customer.firstName + data.customer.lastName : undefined,
      dealType : _dealType === 'APR' ? 'finance' : _dealType,
      dealStatus: data?.deal?.status,
      dealTransactionId: data?.deal?.dealTransactionId,
      salesConsultant: data?.type === 'DEAL_COMMENT' ? data?.deal?.dealTermComment?.commentGivenBy : data?.deal?.salesPerson,
      isNotification: false,
      timestamp: Date.now(),
    };
  
    const navigationExtras: NavigationExtras = {
      // queryParams: { "dealRoute": JSON.stringify(dealRoute) },
      skipLocationChange: false,
      state: dealRoute
    };
    return navigationExtras;
  }
}

